import { defaultTheme, themeByCSSVariables } from '@shared/lib/theme'

export const cellVariants = {
  inverted: 'inverted',
  transparent: 'transparent',
} as const

export const cellBackgroundColor = (variant: keyof typeof cellVariants) => {
  switch (variant) {
    case cellVariants.inverted:
      return themeByCSSVariables.colors.background.inverted
    case cellVariants.transparent:
      return 'transparent'
    default:
      return 'transparent'
  }
}

export const cellIconColor = (variant: keyof typeof cellVariants) => {
  switch (variant) {
    case cellVariants.inverted:
      return themeByCSSVariables.colors.icon.inverted
    case cellVariants.transparent:
      return themeByCSSVariables.colors.icon.secondary
    default:
      return 'transparent'
  }
}

export const cellTextColor = (variant: keyof typeof cellVariants): keyof typeof defaultTheme['colors']['text'] => {
  switch (variant) {
    case cellVariants.inverted:
      return 'inverted'
    case cellVariants.transparent:
      return 'secondary'
    default:
      return 'primary'
  }
}
